import axios from 'axios'
import moment from 'moment'
import { notificationDanger } from '../../../../../utils/customToastify'
import { cleanupObjectWithArrays } from '../../../../../utils/objectUtils'
import {
  GET_OPPORTUNITY_CHART_DATA,
  GET_OPPORTUNITY_CHART_OPPORTUNITIES,
  GET_OPPORTUNITY_CHART_PROSPECTS,
  GET_OPPORTUNITY_CHART_PROSPECT_STAGE,
  OPPORTUNITY_CHART_LOADING,
} from './dashboardOpportunityChartTypes'

export const setLoading = (loading) => (dispatch) => {
  dispatch({ type: OPPORTUNITY_CHART_LOADING, payload: loading })
}

export const getDivisionData = (filters) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    if (!filters.divisionId) {
      notificationDanger('Division must be selected')
    } else if (!filters.dateRange?.from || !filters.dateRange?.to) {
      notificationDanger('Invalid Date Range')
    } else if (!filters.salespersons.length) {
      notificationDanger('Salesperson must be selected')
    } else {
      const normalizedFilters = normalizeFilters(filters)
      const res = await axios.get('/dashboard-opportunity', { params: { filters: { ...normalizedFilters } } })
      dispatch({ type: GET_OPPORTUNITY_CHART_DATA, payload: res.data })
    }
  } finally {
    dispatch(setLoading(false))
  }
}

export const getProspectStage = (type) => async (dispatch) => {
  try {
    const response = await axios.get(`/support-tables/for-select/${type}`)
    dispatch({ type: GET_OPPORTUNITY_CHART_PROSPECT_STAGE, payload: response.data })
  } catch (error) {
    //
  }
}

export const getOpportunities = (stage, options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const normalizedFilters = normalizeFilters(options.filter)
    const opt = { ...options, filter: normalizedFilters }
    const res = await axios.get(`/dashboard-opportunity/${stage}`, { params: { ...opt } })
    dispatch({ type: GET_OPPORTUNITY_CHART_OPPORTUNITIES, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

export const getProspects = (stage, options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const normalizedFilters = normalizeFilters(options.filter)
    const opt = { ...options, filter: normalizedFilters }
    const res = await axios.get(`/dashboard-opportunity/prospects/${stage}`, { params: { ...opt } })
    dispatch({ type: GET_OPPORTUNITY_CHART_PROSPECTS, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

/**
 * removes empty props
 * changes date format for db
 */
const normalizeFilters = (filters) => {
  const cleanedFilters = cleanupObjectWithArrays(filters)
  const {
    dateRange: { from, to },
  } = cleanedFilters
  const dbFrom = moment(from).format('YYYY-MM-DD')
  const dbTo = moment(to).format('YYYY-MM-DD HH:mm:ss')

  return { ...cleanedFilters, dateRange: { from: dbFrom, to: dbTo } }
}
